import { Action } from '@ngrx/store';
import { HttpError, LoyaltyProgram, LoyaltyProgramCategory } from '@rd/types';

export enum LoyaltyProgramActionTypes {
  CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY = '[LoyaltyProgram] Change Filter Category',
  CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD = '[LoyaltyProgram] Change Filter Keyword',
  LOAD_LOYALTY_PROGRAMS = '[LoyaltyProgram] Load LoyaltyPrograms',
  LOAD_LOYALTY_PROGRAMS_SUCCESS = '[LoyaltyProgram] Load LoyaltyPrograms Success',
  LOAD_LOYALTY_PROGRAMS_FAIL = '[LoyaltyProgram] Load LoyaltyPrograms Fail',
}

export class ChangeLoyaltyProgramsFilterCategory implements Action {
  readonly type =
    LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_CATEGORY;

  constructor(public payload: LoyaltyProgramCategory | 'all') {}
}

export class ChangeLoyaltyProgramsFilterKeyword implements Action {
  readonly type =
    LoyaltyProgramActionTypes.CHANGE_LOYALTY_PROGRAMS_FILTER_KEYWORD;

  constructor(public payload: string) {}
}

export class LoadLoyaltyPrograms implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS;
}

export class LoadLoyaltyProgramsSuccess implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_SUCCESS;

  constructor(public payload: LoyaltyProgram[]) {}
}

export class LoadLoyaltyProgramsFail implements Action {
  readonly type = LoyaltyProgramActionTypes.LOAD_LOYALTY_PROGRAMS_FAIL;

  constructor(public payload: HttpError) {}
}

export type LoyaltyProgramActions =
  | ChangeLoyaltyProgramsFilterCategory
  | ChangeLoyaltyProgramsFilterKeyword
  | LoadLoyaltyPrograms
  | LoadLoyaltyProgramsSuccess
  | LoadLoyaltyProgramsFail;
